module.exports = __webpack_public_path__ + "img/地图中文@2x.e190216c.png";